var map = {
	"./icon-activate_extension.svg": "ef52",
	"./icon-answered.svg": "af38",
	"./icon-answered_calls_day.svg": "d7ca",
	"./icon-answered_calls_month.svg": "3ed9",
	"./icon-balance.svg": "f4e9",
	"./icon-busy.svg": "5d63",
	"./icon-call_duration.svg": "5165",
	"./icon-call_duration_day.svg": "a515",
	"./icon-current_status_offline.svg": "9f1f",
	"./icon-current_status_online.svg": "b829",
	"./icon-deactivate_extension.svg": "6f16",
	"./icon-edit.svg": "eaaf",
	"./icon-failed.svg": "b0f5",
	"./icon-filter.svg": "de90",
	"./icon-hold_time.svg": "6c52",
	"./icon-incoming.svg": "d44f",
	"./icon-invoice.svg": "02e0",
	"./icon-local.svg": "3911",
	"./icon-logged_in_since.svg": "8341",
	"./icon-not_answered.svg": "efb0",
	"./icon-outgoing.svg": "2db6",
	"./icon-ticket_number.svg": "f936",
	"./icon-ticket_status.svg": "1d24",
	"./icon-ticket_time.svg": "1cb7",
	"./icon-ticket_type.svg": "67fa",
	"./icon-usage.svg": "9814",
	"./icon-waiting_time.svg": "19a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c43";